export default "__VITE_ASSET__qp0CDHm6__"